import { RefObject, useCallback, useEffect, useRef, useState } from 'react'

export const useIntersection = (ref: RefObject<HTMLElement>, options: IntersectionObserverInit, once: boolean) => {
  const [intersected, setIntersected] = useState(false)
  const intersectedCallback = useCallback(
    (entry: IntersectionObserverEntry[], observer: IntersectionObserver) => {
      if (once && entry[0].isIntersecting) {
        setIntersected(true)
        observer.disconnect()
      } else {
        setIntersected(entry[0].isIntersecting)
      }
    },
    [once]
  )
  const observerRef = useRef(new IntersectionObserver(intersectedCallback, options))

  useEffect(() => {
    const observerRefCurrent = observerRef.current
    ref?.current && observerRefCurrent.observe(ref.current)

    return () => {
      observerRefCurrent.disconnect()
    }
  }, [ref])

  return intersected
}
